import tonStyles from './../ton.json'

export default {
  name: '7',
  type: 'Paragraph',
  color: tonStyles.colors.PrimaryBlack,
  inverseColor: tonStyles.colors.PrimaryWhite
}
